import AbstractMetadata from "../AbstractMetadata";
import EnterpriseComponentAttributeMetadata from "./EnterpriseComponentAttributeMetadata";

export interface IAttributeDictionary<T> {
    [id: string]: T;
}

interface IVisibilityModesDictionary<T = string> {
    [id: string]: T;
}

/**
 * Generic base class for Enterprise Component Metadata
 * T = Type of attribute metadata (defaults to EnterpriseComponentAttributeMetadata)
 */
class EnterpriseComponentMetadata<T extends EnterpriseComponentAttributeMetadata = EnterpriseComponentAttributeMetadata> extends AbstractMetadata {

    public defaultCacheSize: number = 20;

    // Now generic!
    public attributes: IAttributeDictionary<T> = {};

    public visibilityModes: IVisibilityModesDictionary<string> = {};

    getName(): string {
        return this.name;
    }

    getDefaultCacheSize(): number {
        return this.defaultCacheSize;
    }

    getAttributes(): IAttributeDictionary<T> {
        return this.attributes;
    }

    getAttribute(name: string): T | undefined {
        return this.getAttributes()[name];
    }

    getVisibilityModes(): IVisibilityModesDictionary<string> {
        return this.visibilityModes;
    }

    getVisibilityMode(name: string): string | undefined {
        return this.getVisibilityModes()[name];
    }

    /**
     * Helper method for fluent/chained attribute registration
     */
    addAttribute(key: string, attribute: T): this {
        this.attributes[key] = attribute;
        return this;
    }

    /**
     * Helper method for visibility modes
     */
    addVisibilityMode(key: string, mode: string): this {
        this.visibilityModes[key] = mode;
        return this;
    }
}

export default EnterpriseComponentMetadata;